var mp = mp || {};

mp.click_touchstart = (function(){
    return Modernizr.touchEvents ? 'touchstart' : 'click';
})();


// Function for resizing with timeout
//----------------------------------------------------------
$(window).resize(function() {
    if(this.resizeTo) clearTimeout(this.resizeTo);
    this.resizeTo = setTimeout(function() {
        $(this).trigger('resizeEnd');
    }, 200);
});

$(window).bind('resizeEnd', function() {
	setMobileMenuHeight();
	//code to do after window is resized
});